import * as React from 'react'

import { Link, NoticeBox } from '@factorialco/deprecated-design-system'

import { useEffect } from 'modules/core/hooks/useEffect'
import buildUrl from 'modules/core/lib/buildUrl'
import i18n from 'modules/core/lib/i18n'

import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'
import oauthService, { LOGIN_PATH } from 'modules/payroll_integrations_a3innuva/lib/OauthService'

const OauthBanner = () => {
  const [visible, setVisible] = React.useState(false)
  const isBookkeeperView = useBookkeeperView()

  useEffect(() => {
    const checkAuthentication = async () => {
      // We do not have a companyId here to authenticante against with so we pass undefined as companyId
      // so we can know the user is authenticated in a company without knowing which one
      const notAuthenticated = await oauthService.isNotAuthenticated(
        { companyId: undefined },
        isBookkeeperView
      )

      setVisible(notAuthenticated)
    }

    checkAuthentication()
  }, [])

  // TODO: this needs to check that at A3innuva integration
  // is installed in at least one of the bookkeepers companies
  // We need to support multi-company feature flags for this
  // if (!hasFeature('payroll_integrations_a3innuva')) return null

  if (!visible) return null

  return (
    <NoticeBox
      message={i18n.t('payroll_integrations.oauth.banner.message')}
      justifyContent="center"
      component={
        <Link.Href href={buildUrl(LOGIN_PATH)}>
          {i18n.t('payroll_integrations.oauth.banner.link')}
        </Link.Href>
      }
    />
  )
}

export default OauthBanner
